export default __webpack_public_path__ + "static/media/baunebakken-property-01.66468d95.jpg";